<template>
  <main :class="$options.name">
    <Head
      v-for="build in filteredArray"
      :key="build.sys.id"
      :title="build.fields.title + ' | Builds | Nice Bike'"
      :description="'Check out the details behind our build of a ' + build.fields.title"
      keywords="nice bike"
      :image="'https:' + build.fields.hero.fields.file.url + '?fm=jpg&fl=progressive&fit=fill&w=1200&h=630'"
      :url="'https://ridenicebike.com/builds/' + title"
    />
    <section
      v-for="build in filteredArray"
      :key="build.fields.title"
      :class="$options.name + '__wrapper'"
    >
      <Pagination :array="array" :index="index"/>
      <Hero :img="build.fields.hero.fields.file.url">
        <h1>{{ build.fields.title }}</h1>
        <hr>
        <RichText :value="build.fields.description"/>
      </Hero>
      <article>
        <section :class="[$options.name + '__description', 'innerWrap']">
          <header>
            <h2>More about me</h2>
          </header>
          <RichText :value="build.fields.moreAboutMe"/>
        </section>
        <section v-if="build.fields.gallery.length" :class="$options.name + '__gallery'">
          <header>
            <h2>Image gallery</h2>
          </header>
          <section :class="$options.name + '__gallery--wrapper'">
            <Img
              v-for="(img, index) in build.fields.gallery"
              :key="index"
              :alt="img.fields ? img.fields.title + ' image ' + (index + 1):''"
              :src="img.fields ? img.fields.file.url+'?fm=jpg&fl=progressive&fit=fill&w=960':''"
            />
          </section>
        </section>
        <section v-if="build.fields.video" :class="$options.name + '__video'">
          <header>
            <h2>Video</h2>
          </header>
          <section :class="$options.name + '__video--wrapper'">
            <Video :src="build.fields.video.fields.file.url"/>
          </section>
        </section>
        <section :class="$options.name + '__specs'">
          <header>
            <h2>Specs</h2>
          </header>
          <section ion :class="$options.name + '__specs--wrapper'">
            <section>
              <h3>Frameset</h3>
              <section v-if="build.fields.frame">
                <h4>Frame</h4>
                <RichText :value="build.fields.frame"/>
              </section>
              <section v-if="build.fields.fork">
                <h4>Fork</h4>
                <RichText :value="build.fields.fork"/>
              </section>
              <section v-if="build.fields.shifting">
                <h4>Shifting</h4>
                <RichText :value="build.fields.shifting"/>
              </section>
              <h3>Wheels</h3>
              <section v-if="build.fields.wheelset">
                <h4>Wheelset</h4>
                <RichText :value="build.fields.wheelset"/>
              </section>
              <section v-if="build.fields.tires">
                <h4>Tires</h4>
                <RichText :value="build.fields.tires"/>
              </section>
              <section v-if="build.fields.brakes">
                <h4>Brakes</h4>
                <RichText :value="build.fields.brakes"/>
              </section>
            </section>
            <section>
              <h3>Drivetrain</h3>
              <section v-if="build.fields.crank">
                <h4>Crank</h4>
                <RichText :value="build.fields.crank"/>
              </section>
              <section v-if="build.fields.cassette">
                <h4>Cassette</h4>
                <RichText :value="build.fields.cassette"/>
              </section>
              <section v-if="build.fields.chainRings">
                <h4>Chainrings</h4>
                <RichText :value="build.fields.chainRings"/>
              </section>
              <section v-if="build.fields.chain">
                <h4>Chain</h4>
                <RichText :value="build.fields.chain"/>
              </section>
              <section v-if="build.fields.bottomBracket">
                <h4>Bottom Bracket</h4>
                <RichText :value="build.fields.bottomBracket"/>
              </section>
              <section v-if="build.fields.pulleys">
                <h4>Pulleys</h4>
                <RichText :value="build.fields.pulleys"/>
              </section>
              <h3>Cockpit</h3>
              <section v-if="build.fields.bars">
                <h4>Bars</h4>
                <RichText :value="build.fields.bars"/>
              </section>
              <section v-if="build.fields.stem">
                <h4>Stem</h4>
                <RichText :value="build.fields.stem"/>
              </section>
            </section>
            <section>
              <h3 v-if="build.fields.seatpost">Seatpost</h3>
              <section v-if="build.fields.seatpost">
                <RichText :value="build.fields.seatpost"/>
              </section>
              <h3>Finishing Touches</h3>
              <section v-if="build.fields.saddle">
                <h4>Saddle</h4>
                <RichText :value="build.fields.saddle"/>
              </section>
              <section v-if="build.fields.pedals">
                <h4>Pedals</h4>
                <RichText :value="build.fields.pedals"/>
              </section>
              <section v-if="build.fields.cages">
                <h4>Cages</h4>
                <RichText :value="build.fields.cages"/>
              </section>
              <section v-if="build.fields.barTape">
                <h4>Bar Tape</h4>
                <RichText :value="build.fields.barTape"/>
              </section>
              <h3 v-if="build.fields.overlordsAdditions">Overlord’s additions</h3>
              <section v-if="build.fields.overlordsAdditions">
                <RichText :value="build.fields.overlordsAdditions"/>
              </section>
              <h3 v-if="build.fields.finalWeight">Final weight</h3>
              <section v-if="build.fields.finalWeight">
                <RichText :value="build.fields.finalWeight"/>
              </section>
            </section>
          </section>
        </section>
      </article>
    </section>
  </main>
</template>
<script>
import Hero from "@/components/Hero";
import Img from "@/components/Img";
import Pagination from "@/components/Pagination";
import RichText from "@/components/RichText";
import Video from "@/components/Video";
export default {
  name: "Build",
  components: { Hero, Img, Pagination, RichText, Video },
  computed: {
    array() {
      return this.$store.state.builds;
    },
    index() {
      return this.array.findIndex(item => {
        let name = this.title;
        let queried = this.formatLink(item.fields.title);
        return queried === name;
      });
    },
    title() {
      return this.$route.params.build;
    },
    filteredArray() {
      return this.array.filter(item => {
        let name = this.title;
        let queried = this.formatLink(item.fields.title);
        return queried === name;
      });
    }
  },
  methods: {
    formatLink(value) {
      return value.toLowerCase().replace(/[^A-Za-z0-9']/g, "");
    }
  }
};
</script>
<style lang="scss">
.Build {
  article {
    > * + * {
      margin-top: rem(32);
    }
    h2 {
      color: var(--base-mid);
      text-align: center;
    }
    h4 {
      color: var(--base-mid);
    }
  }
  &__description {
    padding: rem(16);
    > * + * {
      margin-top: rem(16);
    }
  }
  &__gallery {
    &--wrapper {
      align-items: start;
      display: grid;
      grid-gap: rem(16);
      grid-template-columns: repeat(auto-fit, minmax(rem(320), 1fr));
      justify-items: center;
      margin: rem(16) 0;
      @include breakpoint(l) {
        grid-template-columns: repeat(auto-fit, minmax(rem(480), 1fr));
      }
      @include breakpoint(xl) {
        grid-template-columns: repeat(auto-fit, minmax(rem(560), 1fr));
      }
      > * {
        border-radius: rem(4);
        box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.5);
        margin: rem(8);
        max-width: 100%;
        overflow: hidden;
      }
    }
  }
  &__video {
    &--wrapper {
      margin-top: rem(16);
      padding: rem(16);
      .Video {
        box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.5);
      }
    }
  }
  &__specs {
    &--wrapper {
      padding: rem(16) 0;
      @include breakpoint(s) {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
      }
      > section {
        flex: 1 1 calc(100% / 3);
        padding: rem(16);
        > * + * {
          margin-top: rem(16);
        }
        h3 {
          margin-top: rem(32);
          width: 100%;
          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>